import { useState, useEffect } from 'react'

interface GeoData {
  zipCode: string
  city: string
  state: string
}

const FALLBACK_ZIP = '33303'

export function useGeoLocation() {
  const [geo, setGeo] = useState<GeoData>({
    zipCode: FALLBACK_ZIP,
    city: '',
    state: '',
  })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchGeo = async () => {
      // ipwho.is is CORS-enabled, key-free, and has a far more generous
      // rate limit than ipapi.co (which was returning 429 / CORS errors).
      try {
        const response = await fetch('https://ipwho.is/')
        if (!response.ok) throw new Error('Geo lookup failed')
        const data = await response.json()
        // ipwho.is returns { success, postal, city, region_code, region }
        if (data && data.success !== false && data.postal) {
          setGeo({
            zipCode: data.postal,
            city: data.city || '',
            state: data.region_code || data.region || '',
          })
        }
      } catch {
        // Silently fall back to default zip — geo is best-effort only.
      } finally {
        setLoading(false)
      }
    }

    fetchGeo()
  }, [])

  return { geo, loading }
}
